import { render, staticRenderFns } from "./businessEnquiries.vue?vue&type=template&id=4eec8d3c&scoped=true&"
import script from "./businessEnquiries.vue?vue&type=script&lang=js&"
export * from "./businessEnquiries.vue?vue&type=script&lang=js&"
import style0 from "./businessEnquiries.vue?vue&type=style&index=0&id=4eec8d3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec8d3c",
  null
  
)

export default component.exports